import * as React from 'react';

import { useQuery } from '@apollo/client';

import { useLocation, useParams } from 'js/lib/useRouter';

import EnterpriseMyPageHeaderContext from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import EnterpriseMyPageHeaderQuery from 'bundles/composable-page-header-enterprise/queries/EnterpriseMyPageHeaderQuery.graphql';
import type {
  EnterpriseMyPageHeaderQuery as EnterpriseMyPageHeaderQueryType,
  EnterpriseMyPageHeaderQueryVariables,
} from 'bundles/composable-page-header-enterprise/queries/__generated__/EnterpriseMyPageHeaderQuery';

const EnterprisePageHeaderBffProvider = ({ children }: { children: React.ReactNode }) => {
  const { programSlug } = useParams();
  const { query } = useLocation();

  // Extra logic to verify that the any type of query?.programSlug is actually a string we can use
  const isQueryAString = (inputQuery: typeof query): inputQuery is string => {
    return !!(inputQuery instanceof String);
  };
  const programSlugFromQuery = query?.programSlug;
  let verifiedProgramSlugFromQuery: string | undefined;
  if (isQueryAString(programSlugFromQuery)) {
    verifiedProgramSlugFromQuery = programSlugFromQuery;
  }

  // Same logic used on line 247 in
  // static/bundles/unified-common/providers/EnterpriseProgramDataProvider.tsx
  const programSlugWithFallback = programSlug || verifiedProgramSlugFromQuery;

  const { data, error } = useQuery<EnterpriseMyPageHeaderQueryType, EnterpriseMyPageHeaderQueryVariables>(
    EnterpriseMyPageHeaderQuery,
    {
      context: {
        clientName: 'gatewayGql',
      },
      errorPolicy: 'all',
      variables: {
        enterpriseProgramSlug: programSlugWithFallback,
      },
    }
  );

  return (
    <EnterpriseMyPageHeaderContext.Provider
      value={{
        myPageHeader: data?.PageHeader?.queryMyPageHeader,
        error,
      }}
    >
      {children}
    </EnterpriseMyPageHeaderContext.Provider>
  );
};

export default EnterprisePageHeaderBffProvider;
